<template>
  <div></div>
</template>

<script setup lang="ts">
const loadJivoSite = () => {
  const widget_id = 'mGbuZU6gEA';

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = `//code.jivosite.com/script/geo-widget/${ widget_id }`;
  document.head.appendChild(script);
}
onMounted(() => {
  setTimeout(() => {
    loadJivoSite();
  }, 10000);
});
</script>

<style scoped lang="scss">

</style>
